import { toast as bulmaToast } from 'bulma-toast';

const TYPE_MAP = {
  danger: 'is-danger',
  warning: 'is-warning',
  success: 'is-success',
  info: 'is-info',
};

// extract: mensagem de erro do backend. toast: toast padrão do sistema
// (type + duration fixos). handler: os dois juntos.
export function extract(err) {
  let message = typeof err === 'string'
    ? err
    : err?.response?.data?.error?.message
      ?? err?.response?.data?.message
      ?? err?.error?.response?.data?.error?.message
      ?? err?.error?.data?.message
      ?? err?.data?.error?.message
      ?? err?.message
      ?? err;

  if (err?.response?.data?.error?.errors) {
    const errors = Object.values(err?.response?.data?.error?.errors);

    message = message.concat(`<br> - ${errors.map((error) => error).join('<br> - ')}`);
  }

  return message;
}

export function toast(message, type = 'danger', { single = false } = {}) {
  bulmaToast({
    message,
    type: TYPE_MAP[type] ?? TYPE_MAP.danger,
    dismissible: true,
    pauseOnHover: true,
    animate: { in: 'fadeIn', out: 'fadeOut' },
    position: 'top-center',
    closeOnClick: true,
    duration: 10000,
    // bulma-toast does not tell types apart: `single: true` clears every earlier
    // toast in the container (top-center here) before showing the new one, so
    // validation toasts do not pile up on each "Continuar" click.
    single,
  });
}

export function handler(err, type = 'danger') {
  toast(extract(err), type);
}
